export default __webpack_public_path__ + "static/media/qc_photo-2.0d56005c.jpg";